import { render } from "./HelpBulkUpload.vue?vue&type=template&id=1b844fda"
import script from "./HelpBulkUpload.vue?vue&type=script&lang=js"
export * from "./HelpBulkUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__